import { render, staticRenderFns } from "./MovementBtLocations.vue?vue&type=template&id=0c3db4be&scoped=true"
import script from "./MovementBtLocations.vue?vue&type=script&lang=js"
export * from "./MovementBtLocations.vue?vue&type=script&lang=js"
import style0 from "./MovementBtLocations.vue?vue&type=style&index=0&id=0c3db4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3db4be",
  null
  
)

export default component.exports